import { render, staticRenderFns } from "./WorkflowStepIcon.vue?vue&type=template&id=5e0b0a2a"
import script from "./WorkflowStepIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkflowStepIcon.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports